<div 
    *ngIf="this.recordOfChanges.length > 0" class="z-50 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseHistory();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-md flex flex-col my-6 p-8 bg-white rounded-md shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
            <div class="w-full flex flex-col items-center justify-between pb-2">
                <h2 class="w-full oswald-font text-2xl text-nside-orange-400">Record of Changes Case {{ caseId }}</h2>
            </div>
            <ol class="h-full overflow-y-auto relative border-s border-gray-200 dark:border-gray-700">
                <li *ngFor="let record of recordOfChanges" class="mb-5 ms-4">
                    <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white"></div>
                    <p class="mb-1 text-sm font-normal leading-none text-gray-400">
                        {{ record.date | date: 'MM/dd/yyyy - HH:mm' }}
                    </p>
                    <h3 class="text-lg font-semibold text-gray-900">
                        {{ record.description }}
                    </h3>
                    <p *ngIf="record.note" class="text-base font-normal text-nside-orange-400">
                        <span class="font-semibold">Rejection Note:</span> {{ record.note }}
                    </p>
                    <p class="mb-4 text-sm font-normal text-gray-500">
                        By {{ record.name }}
                    </p>
                </li>
            </ol>
            <div class="mt-4 flex justify-end gap-4">
                <button
                    class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    (click)="$event.preventDefault(); handleCloseHistory();"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
